import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default class Icon extends PureComponent {
  static propTypes = {
    icon: PropTypes.string.isRequired,
    className: PropTypes.string,
    brand: PropTypes.bool,
    size: PropTypes.oneOf([
      'xs',
      'sm',
      'lg',
      '2x',
      '3x',
      '4x',
      '5x',
      '6x',
      '7x',
      '8x',
      '9x',
      '10x',
    ]),
    fixedWidth: PropTypes.bool,
    inverse: PropTypes.bool,
    listItem: PropTypes.bool,
    rotation: PropTypes.number,
    flip: PropTypes.oneOf(['horizontal', 'vertical', 'both']),
    spin: PropTypes.bool,
    pulse: PropTypes.bool,
    border: PropTypes.bool,
    pull: PropTypes.oneOf(['left', 'right']),
    transform: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    mask: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.arrayOf(PropTypes.string),
    ]),
    symbol: PropTypes.string,
  };

  get icon() {
    const { icon, brand } = this.props;

    if (brand) return ['fab', icon];

    return ['fal', icon];
  }

  render() {
    const props = _.pick(this.props, [
      'className',
      'size',
      'fixedWidth',
      'inverse',
      'listItem',
      'rotation',
      'flip',
      'spin',
      'pulse',
      'border',
      'pull',
      'transform',
      'mask',
      'symbol',
    ]);

    return <FontAwesomeIcon icon={this.icon} {...props} />;
  }
}



// WEBPACK FOOTER //
// ../pos-master/packages/pos-components/src/Icon/Icon.jsx